import { createFileRoute } from "@tanstack/react-router";
import { useSuspenseQuery } from "@tanstack/react-query";
import { suspenseOptions } from "@/lib/suspense-query";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { getGetBulkProductQueryOptions } from "@/requests/gen/react-query/bulk-product";
import BulkProductCreateForm from "../-form";
import { BulkProductCrumbs } from "../-crumbs";
import numericId from "@/lib/numeric-id";

export const Route = createFileRoute(
  "/_private/_practice-360/bulk-product/$bulkProductId/edit",
)({
  loader: ({ context: { queryClient }, params: { bulkProductId } }) =>
    queryClient.ensureQueryData(
      getGetBulkProductQueryOptions(numericId(bulkProductId)),
    ),
  component: BulkProductEditPage,
});

function BulkProductEditPage() {
  const { bulkProductId } = Route.useParams();
  const { data: bulk_product } = useSuspenseQuery(
    suspenseOptions(getGetBulkProductQueryOptions(numericId(bulkProductId))),
  );

  return (
    <div>
      <title>
        {`Edit ${bulk_product?.catalog_product.product_base.name || "Bulk Product"} - Legrande Health Portal`}
      </title>
      <BulkProductCrumbs />
      <Card>
        <CardHeader>
          <CardTitle>Edit Bulk Product</CardTitle>
          <CardDescription>Enter product details below.</CardDescription>
        </CardHeader>
        <CardContent>
          {bulk_product && (
            <BulkProductCreateForm bulk_product={bulk_product} />
          )}
        </CardContent>
      </Card>
    </div>
  );
}
